export const GEOLOCATION_ERROR_CODE = {
  PERMISSION_DENIED: 1,
  POSITION_UNAVAILABLE: 2,
  TIMEOUT: 3,
}

export function isValidGeolocationCoordinates(lat, lng) {
  const latitude = Number(lat)
  const longitude = Number(lng)
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return false
  }
  return !(latitude === 0 && longitude === 0)
}

export function mapGeolocationErrorToI18nKey(
  error,
  { permissionKey, unavailableKey } = {},
) {
  const code = error?.code
  if (code === GEOLOCATION_ERROR_CODE.PERMISSION_DENIED) {
    return permissionKey ?? null
  }
  if (
    code === GEOLOCATION_ERROR_CODE.POSITION_UNAVAILABLE ||
    code === GEOLOCATION_ERROR_CODE.TIMEOUT
  ) {
    return unavailableKey ?? null
  }

  const message = String(error?.message ?? '')
  if (/invalid coordinates|position update is unavailable|timeout expired/i.test(message)) {
    return unavailableKey ?? null
  }
  if (/not supported|permission|denied/i.test(message)) {
    return permissionKey ?? null
  }

  return null
}

export function getGeolocation({ maximumAge = 60_000 } = {}) {
  return new Promise((resolve, reject) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      reject(new Error('Geolocation is not supported'))
      return
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude
        const lng = position.coords.longitude
        if (!isValidGeolocationCoordinates(lat, lng)) {
          reject(new Error('Invalid coordinates'))
          return
        }
        resolve({ lat, lng })
      },
      (error) => {
        reject(error)
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge,
      },
    )
  })
}
